import { useQuery, useQueryClient } from 'react-query';
import is from 'is_js';

import { fetchRestaurant, fetchPaymentData } from '../restaurant';
import { fetchOrderSituation } from '../payment';
import { fetchExperiences } from '../experience';

export function useRestaurant() {
    const queryClient = useQueryClient();
    const restaurant = localStorage.getItem('restaurant');

    return useQuery(
        'restaurant',
        async () => {
            const data = await fetchRestaurant(restaurant);
            queryClient.setQueryData('restaurant', data);
            if (data) return data;
            return {};
        },
        { staleTime: Infinity, enabled: is.truthy(restaurant) },
    );
}

export function usePayment() {
    const queryClient = useQueryClient();
    const restaurant = queryClient.getQueryData('restaurant')?.id || '';

    return useQuery('payment', async () => {
        const data = await fetchPaymentData(restaurant);
        if (data) return data;
        return [];
    });
}

export function useOrderStatus(order) {
    const queryClient = useQueryClient();
    const restaurant = queryClient.getQueryData('restaurant')?.id || '';

    return useQuery(
        'order',
        async () => {
            const data = await fetchOrderSituation(order);
            if (data) return data;
            return [];
        },
        { staleTime: Infinity, enabled: is.truthy(restaurant) },
    );
}

export function useExperiences() {
    const queryClient = useQueryClient();
    const restaurant = queryClient.getQueryData('restaurant')?.id || '';

    return useQuery(
        'experiences',
        async () => {
            const data = await fetchExperiences(restaurant);
            if (data) return data;
            return [];
        },
        { staleTime: Infinity, enabled: is.truthy(restaurant) },
    );
}
